import script from "./BuyLeft.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyLeft.vue?vue&type=script&setup=true&lang=js"

import "./BuyLeft.vue?vue&type=style&index=0&id=63799070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63799070"]])

export default __exports__